// extracted by mini-css-extract-plugin
export var link = "styles-module--link--a4bf9";
export var pdp = "styles-module--pdp--61ab9";
export var tile = "styles-module--tile--9593e";
export var tiles_container = "styles-module--tiles_container--496dd";
export var title = "styles-module--title--ab97c";